import React, { useEffect } from 'react';
import Banner from '../Common_Component/Banner/Banner'
import Below_Banner_section from '../Common_Component/Below_Banner_section/Below_Banner_section'
import Inquiry from './Inquiry/Inquiry'
import All_Services from './All_Services/All_Services';

const Service = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
      },);
    return (
        <>

            <Banner videoSrc={"/Assets/Vedio/Services/Services_outer.mp4"} />
            <All_Services/>
            <Inquiry/>
        </>
    )
}

export default Service
